export default "__VITE_ASSET__peepdguH__"